export default __webpack_public_path__ + "static/summer_containers24-131590df98a89bd42ff528402dcbb217.webp";